import ChatRecordData from "./chatrecorddata";
import TextureManager from "../../../../manager/texture_manager";
import Utility from "../../../../utility/utility";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ChatRecordItem extends cc.Component {
    _msgLabel = null
    _bgNode = null
    lastHeight = 0
    _start = false

    RefreshShow(data: ChatRecordData) {
    }

    setData(data: ChatRecordData) {
        let item = this.node
        let isMyself = (data.myselfId == data.playerId)
        let myNode = item.getChildByName("My")
        let otherNode = item.getChildByName("Other")
        myNode.active = isMyself
        otherNode.active = !isMyself
        let targetNode: cc.Node = isMyself ? myNode : otherNode
        let iconSprite = cc.find("Node/HeadRoot/Mask/image", targetNode).getComponent(cc.Sprite)
        let frameSprite = cc.find("Node/HeadRoot/Frame", targetNode).getComponent(cc.Sprite)
        let nameLabel = cc.find("Node/NickName", targetNode).getComponent(cc.Label)
        let msgLabel = cc.find("Node/ChatRoot/AutoHight/RealShow", targetNode).getComponent(cc.Label)
        let bgNode = cc.find("Node/ChatRoot/AutoHight/BG", targetNode)
        msgLabel.string = data.chatShowText
        this._msgLabel = msgLabel
        this._bgNode = bgNode
        this._start = true
        this.refreshHight(msgLabel)
        item.active = true
        let self = this
        // RunfastData.instance.getRoleDataAsyn(data.playerId, (roleData) => {
        //     nameLabel.string = roleData.nickname
        //     let vipName = Utility.getVipPath(roleData.vipLevel)
        //     TextureManager.instance.getLocalSprite(vipName, (frame) => {
        //         if (self && self.isValid && frame) {
        //             frameSprite.spriteFrame = frame
        //         }
        //     })

        //     roleData.headImg = Utility.getUserHeadImagePath(roleData.headImg)
        //     TextureManager.instance.getSprite(roleData.headImg, (frame) => {
        //         if (self && self.isValid && frame) {
        //             frame.setOriginalSize(cc.size(70, 70))
        //             iconSprite.spriteFrame = frame
        //         }
        //     })
        // })
    }

    refreshHight(msgLabel) {
        let height = msgLabel.node.height
        this.lastHeight = msgLabel.lineHeight
        this._bgNode.height = height + 10
        let dif = height - msgLabel.lineHeight * 2 - 3//留3个像素
        if (dif > 0) {
            this.node.height = 86 + dif//86 刚好不超出的高度
        }
    }

    update() {
        if (this._msgLabel.node.height != this.lastHeight) {
            this._start = false
            this.refreshHight(this._msgLabel)
        }
    }

}